import { useCallback } from 'react';

import { useLocation, useParams, useSearchParams } from 'react-router';

import { useNav } from './hooks';
import { withHookMoveToLink } from './nav';
import Routes from './routes';

export function useUrlParams() {
  const goto = useNav();
  const { pathname } = useLocation();
  const { lead_id: paramLeadId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const isPublic = searchParams.get(window.btoa('is_rep')) !== window.btoa('true');

  const saleAlias = searchParams.get('sale_alias');
  const summaryId = searchParams.get('cp_id');
  const campusId = searchParams.get('campus_id');
  const isDev = searchParams.get('is_dev') === 'true';
  const isReviseMode = searchParams.get('tc') === 'revised';
  const isDiscountCheckoutMode = searchParams.get('tc') === 'discount_checkout';
  const devStartBillingDate = searchParams.get('start_billing');
  const devAgreementDate = searchParams.get('agreement_date_time');
  const linkValidationKey = searchParams.get('v_key') ? encodeURIComponent(searchParams.get('v_key') || '') : '';

  const resolvedCurrentPath = pathname.replace(`/${paramLeadId}/`, '').replace('/consent', '/checkout');
  const isConsentPage = pathname.indexOf('/consent') > -1;
  const isBridgePlanPage = pathname === `${Routes.BRIDGE_PLAN.link}/${paramLeadId ?? ''}/`;

  const deleteParams = useCallback(
    (p: string[]) => {
      p.forEach((i) => {
        searchParams.delete(i);
      });
      return searchParams;
    },
    [searchParams]
  );

  const moveToLink = useCallback((link: string, _searchParams?: string, isSpecial?: boolean) => {
    withHookMoveToLink(goto, paramLeadId as string, link, _searchParams, isSpecial);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    setSearchParams,
    deleteParams,
    moveToLink,
    searchParams,
    paramLeadId: paramLeadId || '',
    isPublic,
    isDev,
    isReviseMode,
    isDiscountCheckoutMode,
    devStartBillingDate,
    devAgreementDate,
    saleAlias: saleAlias || '',
    paramSummaryId: summaryId || '',
    paramCampusId: campusId || '',
    linkValidationKey,
    resolvedCurrentPath,
    isConsentPage,
    isBridgePlanPage,
  };
}
